import { Button } from '@/components/ui/button';
import { ChannelIcon } from '@/components/ui/channel-icon';
import { Typography } from '@/components/ui/typography';
import { PlaneSendIcon } from '@/components/icons/plane-send';

import {
  INDEED,
  JOVEO,
  POOL,
  TALROO,
  ZIPRECRUITER,
} from '@/types/channels';
import { FormattedMessage } from 'react-intl';
import { useJobPostingContext } from '@/contexts/job-posting-context';
import { useOpeningDetails } from '@/contexts/opening-context';

export function JobPostingCard() {
  const { opening } = useOpeningDetails();
  const { openJobPostingForm } = useJobPostingContext();
  const channels = [INDEED, ZIPRECRUITER, POOL, JOVEO, TALROO];

  const handlePostJobClick = () => {
    openJobPostingForm({
      openings: [{ id: opening.id, title: opening.title }],
    });
  };

  return (
    <>
      <Typography as="h2" variant="caption">
        <FormattedMessage
          defaultMessage="Post to job boards"
          description="Title for the job posting card"
        />
      </Typography>
      <div className="pb-6">
        <div className="border-fx-neutral-200 flex items-center justify-between gap-4 rounded-lg border bg-white p-4 shadow-sm">
          <div className="flex flex-col gap-3">
            <div className="flex gap-1">
              {/* Channel icons */}
              <div className="flex">
                {channels.map(channel => (
                  <ChannelIcon
                    key={channel}
                    variant="small"
                    size="xs"
                    channelSlug={channel}
                    className="-mr-1 last:mr-0"
                  />
                ))}
              </div>
              <Typography variant="small1" className="text-fx-neutral-600">
                <FormattedMessage
                  defaultMessage="2,000+ boards available"
                  description="Description for the job posting card"
                />
              </Typography>
            </div>

            {/* Title and description */}
            <div className="flex flex-col gap-1">
              <Typography variant="h6">
                <FormattedMessage
                  defaultMessage="Ready to source this opening?"
                  description="Title for the job posting card"
                />
              </Typography>

              <Typography variant="subtitle1" className="text-fx-neutral-600">
                <FormattedMessage
                  defaultMessage="Post across job boards, ad platforms, and your own contracts. Source picks the best fit for your role and budget — or you can choose manually."
                  description="Description for the job posting card"
                />
              </Typography>
            </div>
          </div>

          {/* Button */}
          <Button variant="secondary" onClick={handlePostJobClick}>
            <PlaneSendIcon />
            <FormattedMessage
              defaultMessage="Post job"
              description="Button to post the job"
            />
          </Button>
        </div>
      </div>
    </>
  );
}
